import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Table, Icon} from 'semantic-ui-react';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import {sumBy} from 'lodash';
import './table.scss';

class LiquidationsSummary extends Component {
  state = {'activeIndex': 0}

  handleClick = (e, titleProps) => {
    const {index} = titleProps;
    const {activeIndex} = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({'activeIndex': newIndex});
  }

  render() {
    return (
      <Accordion className='liquidations-summary'
        fluid>
        {this.getAccordionItems()}
      </Accordion>
    );
  }

  getAccordionItems() {
    const {activeIndex} = this.state;

    const {data} = this.props;

    const header = [
      this.buildAccordionTitle(0, activeIndex, {'name': 'NOMBRE', 'total': 'TOTAL', 'class': 'header'}),
      this.buildAccordionContent(0, activeIndex, []),
    ];

    const result = data.map((element, index) => {
      return [
        this.buildAccordionTitle(index + 1, activeIndex, element),
        this.buildAccordionContent(index + 1, activeIndex, element.detail),
      ];
    });

    result.push(
      this.buildAccordionTitle(data.length + 1, activeIndex, {'name': 'TOTAL', 'total': sumBy(data, 'total')}),
      this.buildAccordionContent(data.length + 1, activeIndex, [])
    );

    return header.concat(result);
  }

  buildAccordionTitle(index, activeIndex, value) {
    return <Accordion.Title key={`accordionTitle${index.toString()}`} active={activeIndex === index}
      index={index}
      onClick={this.handleClick}>
      {this.renderTitleSection(value)}
    </Accordion.Title>;
  }

  buildAccordionContent(index, activeIndex, value) {
    return <Accordion.Content key={`accordionContent${index.toString()}`} active={activeIndex === index}>
      {this.renderContentSection(value)}
    </Accordion.Content>;
  }

  renderTitleSection(element) {
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={8} textAlign='left'>{element.name}</Table.HeaderCell>
            <Table.HeaderCell width={6} textAlign='center'>{element.total}</Table.HeaderCell>
            <Table.HeaderCell width={2} textAlign='center'>
              {element.detail ? <Icon name='dropdown' /> : ''}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      </Table>
    );
  }

  renderContentSection(detail) {
    if (!detail || detail.length === 0) {
      return (<div />);
    }
    return (
      <Table striped className='scrollable-body'>
        <Table.Body>
          {this.renderItems(detail)}
        </Table.Body>
      </Table>
    );
  }

  renderItems(list) {
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell width={10} textAlign='left'>{element.chassis}</Table.Cell>
          <Table.Cell width={6} textAlign='right'>{getNumericValue(element.cfr, 2)}</Table.Cell>
        </Table.Row>
      );
    });
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.liquidationsList.loadingDetail,
  };
};

export default connect(mapStateToProps, {
})(LiquidationsSummary);
